<ng-container *ngIf="!modoAdminHotel">
    <app-superadmin-navbar></app-superadmin-navbar>
</ng-container>
<ng-container *ngIf="modoAdminHotel">
    <app-navbar></app-navbar>
</ng-container>
<div class="create-admin">
    <div class="register-container">
        <h2 class="register-title">Registrar usuario recepcionista</h2>
    </div>

    <!-- Inline message container -->
    <div *ngIf="message" class="form-message" [ngClass]="{
      'form-message--success': messageType === 'success',
      'form-message--error': messageType === 'error',
      'form-message--info': messageType === 'info'
    }">
      {{ message }}
    </div>

    <form class="register-form" (ngSubmit)="register()">
        <div class="form-group">
            <label for="email" class="form-label">Correo electrónico</label>
            <input type="email" id="email" name="email" class="form-input" [(ngModel)]="email"
                placeholder="name@gmail.com" required />
        </div>

        <div class="form-group">
            <label for="name" class="form-label">Primer nombre</label>
            <input type="text" id="name" name="firstName" class="form-input" [(ngModel)]="given_name"
                placeholder="Tu primer nombre" required />
        </div>

        <div class="form-group">
            <label for="lastName" class="form-label">Apellidos</label>
            <input type="text" id="lastName" name="lastName" class="form-input" [(ngModel)]="family_name"
                placeholder="Tus apellidos" required />
        </div>

        <div class="form-group">
            <label for="numberDocument" class="form-label">Número de documento</label>
            <input type="text" id="numberDocument" name="NumDocument" class="form-input" [(ngModel)]="document_number"
                placeholder="1234567890" required />
        </div>

                <div class="form-group">
                        <label for="group" class="form-label">Grupo</label>
                        <ng-container *ngIf="!modoAdminHotel">
                            <select id="group" name="group" class="form-input" [(ngModel)]="group" required>
                                    <option value="superadmin">Superadmin</option>
                                    <option value="admin-hotel">Admin Hotel</option>
                                    <option value="admin-recepcion">Admin Recepción</option>
                            </select>
                        </ng-container>
                        <ng-container *ngIf="modoAdminHotel">
                            <input type="text" class="form-input" value="Recepcionista" disabled />
                        </ng-container>
                </div>

        <div class="form-group">
            <label class="form-label">Alojamientos a administrar (opcional) test</label>
            <button type="button" class="add-hostings-btn" (click)="toggleHostings()">
            {{ showHostings ? 'Ocultar alojamientos' : 'Agregar alojamientos' }}
            </button>

            <div *ngIf="showHostings">
                <div *ngIf="loadingHostings" style="color: #2563eb;">Cargando alojamientos...</div>
                <div *ngIf="!loadingHostings && hostings.length === 0" style="color: #b91c1c;">No hay alojamientos
                    disponibles.</div>
                <div *ngIf="!loadingHostings && hostings.length > 0">
                    <div class="hostings-cards-select">
                        <div class="hosting-card-select" *ngFor="let hosting of hostings">
                            <label class="card-label">
                                <input type="checkbox" [value]="hosting.id"
                                    [checked]="selectedHostings.includes(hosting.id)"
                                    (change)="onAlojamientoCheckboxChange($event, hosting.id)"
                                    class="hosting-checkbox" />
                                <div class="hosting-img-wrap">
                                    <img *ngIf="hosting.images && hosting.images.length" [src]="hosting.images[0]"
                                        alt="Alojamiento" class="hosting-img-select" />
                                </div>
                                <div class="hosting-info-select">
                                    <div class="card-title">{{ hosting.name || hosting.title }}</div>
                                    <div class="card-detail">Tipo: {{ hosting.type }}</div>
                                    <div class="card-detail" *ngIf="hosting.location?.city">
                                        <span class="icon-location">📍</span> {{ hosting.location.city }}
                                    </div>
                                    <div class="card-detail" *ngIf="hosting.location?.adress">
                                        <span class="icon-address">🏠</span> {{ hosting.location.adress }}
                                    </div>
                                    <div class="card-id">ID: {{ hosting.id }}</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="password" class="form-label">Contraseña</label>
            <input type="password" id="password" name="password" class="form-input" [(ngModel)]="password" required />
        </div>

        <div class="form-group">
            <label for="repeat-password" class="form-label">Confirma contraseña</label>
            <input type="password" id="repeat-password" name="confirmPass" class="form-input" [(ngModel)]="confirmPass"
                required />
        </div>

        <button type="submit" class="submit-button">Registrar usuario</button>
    </form>
</div>